// extracted by mini-css-extract-plugin
module.exports = {"delete-update":"delete_update_activity__delete-update___19Ifl"};